/**
 * Integration map visual constants — edge type colors, layout defaults.
 */

export const RELATIONSHIP_TYPES = {
  data_flow: { label: 'Data Flow', color: '#3b82f6', dash: '' },
  approval: { label: 'Approval', color: '#f59e0b', dash: '6,3' },
  reporting: { label: 'Reporting', color: '#8b5cf6', dash: '' },
  resource_sharing: { label: 'Resource Sharing', color: '#10b981', dash: '3,3' },
  dependency: { label: 'Dependency', color: '#ef4444', dash: '' },
  custom: { label: 'Custom', color: '#94a3b8', dash: '6,3' },
} as const;

export type RelationshipType = keyof typeof RELATIONSHIP_TYPES;

export const HEALTH_COLORS: Record<string, string> = {
  healthy: '#22c55e',
  warning: '#eab308',
  critical: '#ef4444',
  unknown: '#64748b',
};

export const NODE_RADIUS = 32;
export const LABEL_OFFSET = 48;
export const HEALTH_BADGE_RADIUS = 6;
